import React, { useEffect, useState, useRef } from "react";
import { Navigate, useNavigate } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { FiAlertTriangle } from "react-icons/fi";
import { BiSolidPlaneLand } from "react-icons/bi";
import { FaArrowsRotate } from "react-icons/fa6";
import { FaBellConcierge } from "react-icons/fa6";
import { IoIosTimer } from "react-icons/io";

import idcardcss from '../pages/css/idcard.module.css';
import {
    getmycleaningassignments,
    startassigment,
    startRecleanassigment,
    stopassigment,
    stopRecleanassigment,
    reportassigmentissue,
    ReportIssueassigment,
    createIssue,
    getIssuefromCleaningAssignment, updateIssue,
    getCleaningtasks,
    getCleaningtypebyId,
    dndassigment,
    getView
} from "../dbconnector/connector";
import { saveFile } from "../tools/filehandler";
import { setErrorMessage, setMessage, clearMessage } from "../tools/errorhandling";
import { ImExit } from "react-icons/im";
import { FaBed } from "react-icons/fa";
import { IoIosFlash } from "react-icons/io";
import { FaRegStar } from "react-icons/fa";
import { BsCalendar2DayFill } from "react-icons/bs";
import { FaCalendarWeek } from "react-icons/fa6";
import { FaCalendarXmark } from "react-icons/fa6";
import { FaServicestack } from "react-icons/fa";
import Cookies from "universal-cookie";
import { use } from "react";
import { confirmAlert } from 'react-confirm-alert';


const MyCleaningTasks = ({ translation: t, checkindata: checkindata }) => {
    let reloadAsked = false;
    const reloadAskedRef = useRef(false);
    const assignmentsRef = useRef([]);
    const [startinterval, setStartinterval] = useState(false);
    const [cleaningassignments, setCleaningassignments] = useState([]);
    const [cleaningassignmentsreload, setCleaningassignmentsreload] = useState([]);
    const [filteredcleaningassignments, setfilteredcleaningassignments] = useState([]);
    const [cleaningassignmentsarray, setcleaningassignmentsarray] = useState([]);

    const [issues, setIssues] = useState({});
    const [defaultIssues, setdefaultIssues] = useState({});
    const [picturesarray, setPicturesarray] = useState([]);
    const [dndpicturesarray, setDNDPicturesarray] = useState([]);
    const [save, setSave] = useState(0);
    const [issueid, setIssueid] = useState(null);
    const [runningassignment, setRunningassignment] = useState(null);
    const [assigmentstarted, setAssigmentstarted] = useState(0);
    const [assigmentissueReported, setAssigmentissueReported] = useState(0);
    const [assignmentDescriptions, setAssignmentDescriptions] = useState({});
    const [hotelID, setHotelID] = useState(null);
    const [QAcontrole, setQAControl] = useState(3);
    const [checkinobject, setCheckinobject] = useState(undefined)

    const navigate = useNavigate()

    const optionstypes = {
        0: t("Blijver"),
        1: t("Vertrekker"),
        2: t("Flitskamer"),
        3: t("dailyclean"),
        4: t("weeklyClean"),
        5: t("finalClean")
    };


    useEffect(() => {
        assignmentsRef.current = cleaningassignments;
    }, [cleaningassignments]);


    useEffect(() => {
        const interval = setInterval(async () => {
            if (reloadAskedRef.current) return;

            const currentAssignments = assignmentsRef.current;

            try {
                const res = await getmycleaningassignments();

                if (res.status !== 200) return;

                const newAssignments = await res.json();

                const differences = findMismatchedById(
                    newAssignments,
                    currentAssignments
                );

                if (differences.length > 0) {
                    reloadAskedRef.current = true;
                    Doreloadassignments(newAssignments);
                }
            } catch (err) {
                console.error(err);
            }
        }, 60000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (hotelID !== null) {
            getView("hotelgenerals", "HotelID", hotelID).then(res => {
                if (res.status === 200) {
                    res.json().then(res => {
                        setQAControl(res[0].Perform_QAControl)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })

        }
    }, [hotelID]);


    useEffect(() => {
        setCheckinobject(checkindata)
        //console.log("checkindata mycleaningassignments", cleaningassignments)
        if (checkindata.inout === undefined || checkindata.type === undefined) {
            // setMessage(t("message_notCheckedIn"))
        } else if (checkindata.inout === "out" && checkindata.type === "work") {

            setMessage(t("message_notCheckedIn"))
        } else if (checkindata.inout === "in" && checkindata.type === "pause") {

            setMessage(t("message_notCheckedInPause"))

        } else if (checkindata.inout === "in" && checkindata.type === "work") {
            clearMessage()
            FilterAssignments();
            const loadDescriptions = async () => {
                const newDescriptions = {};
                if (cleaningassignments.assignments?.length > 0) {
                    for (const assignment of cleaningassignments.assignments) {
                        newDescriptions[assignment.id] = await generatedescription(assignment);
                    }
                }
                if (cleaningassignments.defaults?.length > 0) {
                    for (const assignment of cleaningassignments.defaults) {
                        newDescriptions[assignment.id] = await generatedescription(assignment);
                    }
                }
                setAssignmentDescriptions(newDescriptions);
            };
            loadDescriptions();

        }
    }, [cleaningassignments, checkindata]);


    useEffect(() => {
        const cleaning = document.getElementById("IconCleaning");
        const data = document.getElementById("IconMyData");
        const holiday = document.getElementById("IconMyHoliday");
        const contract = document.getElementById("IconMyContract");

        if (cleaning) cleaning.style.display = "block";
        if (data) data.style.display = "none";
        if (holiday) holiday.style.display = "none";
        if (contract) contract.style.display = "none";

        reloadassignments();
    }, [checkindata]);


    const FilterAssignments = () => {
        let filtered = []
        let defaultfiltered = []
        if (cleaningassignments.assignments && cleaningassignments.assignments.length > 0) {
            filtered = cleaningassignments.assignments.filter(assignment => {

                if (assignment.hotel_id === checkindata.hotel_id) {
                    setHotelID(assignment.hotel_id)
                    return assignment
                }
            })
        }

        if (cleaningassignments.defaults && cleaningassignments.defaults.length > 0) {
            defaultfiltered = cleaningassignments.defaults.filter(assignment => {
                if (assignment.hotel_id === checkindata.hotel_id) {
                    return assignment
                }

            })
        }
        setfilteredcleaningassignments({ assignments: filtered, defaults: defaultfiltered || [] });

    };


    function findMismatchedById(listA, listB) {
        try {
            const idsA = new Set(listA.assignments.map(item => item.id));
            const idsB = new Set(listB.assignments.map(item => item.id));

            const onlyInA = listA.assignments.filter(item => !idsB.has(item.id));
            const onlyInB = listB.assignments.filter(item => !idsA.has(item.id));

            const defaultsidsA = new Set(listA.defaults.map(item => item.id));
            const defaultsidsB = new Set(listB.defaults.map(item => item.id));

            const defaultsonlyInA = listA.defaults.filter(item => !defaultsidsB.has(item.id));
            const defaultsonlyInB = listB.defaults.filter(item => !defaultsidsA.has(item.id));



            return [...onlyInA, ...onlyInB, ...defaultsonlyInA, ...defaultsonlyInB];

        }
        catch {
            return []
        }
    }

    const Doreloadassignments = async (newlist) => {


        const options = {
            title: t('NewAssignmentsdetected'),
            message: t('NewAssignmentsdetectedMessage'),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        setCleaningassignments([])
                        setCleaningassignments(prev => newlist)
                        //reloadassignments()
                        reloadAskedRef.current = false

                    }
                },
                {
                    label: t('No'),
                    onClick: () => {
                        reloadAskedRef.current = false
                    }
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            overlayClassName: "overlay-custom-class-name"
        };


        confirmAlert(options);

    }


    const reloadassignments = async () => {
        if (checkindata.inout === undefined || checkindata.type === undefined) {
            // setMessage(t("message_notCheckedIn"))
        }
        else if (checkindata.inout === "out" && checkindata.type === "work") {

            setMessage(t("message_notCheckedIn"))
        } else if (checkindata.inout === "in" && checkindata.type === "pause") {
            setMessage(t("message_notCheckedInPause"))

        } else if (checkindata.inout === "in" && checkindata.type === "work") {
            // setcleaningassignmentsarray([])
            clearMessage()
            await getmycleaningassignments().then(res => {
                if (res.status === 200) {
                    res.json().then(data => {
                        setCleaningassignments(structuredClone(data));
                        setStartinterval(true);
                        console.log("assignments loaded ", data)
                    }
                    );

                } else {
                    setErrorMessage(res.statusText);
                }
            });


        } else {

        }

    };

    useEffect(() => {
        if (!filteredcleaningassignments.assignments?.length && !filteredcleaningassignments.defaults?.length) return;

        const issuePromises = filteredcleaningassignments.assignments?.map(assignment =>

            getIssuefromCleaningAssignment(assignment.id)
                .then(res => res.status === 200 ? res.json() : null)
                .then(data => ({ id: assignment.id.toString(), data }))
                .catch(() => ({ id: assignment.id.toString(), data: null }))
        ) || [];

        const defaultPromises = filteredcleaningassignments.defaults?.map(assignment =>
            getIssuefromCleaningAssignment(assignment.id)
                .then(res => res.status === 200 ? res.json() : null)
                .then(data => ({ id: assignment.id.toString(), data }))
                .catch(() => ({ id: assignment.id.toString(), data: null }))
        ) || [];

        Promise.all(issuePromises).then(results => {
            const newIssues = {};
            results.forEach(({ id, data }) => {
                if (data) newIssues[id] = data;
            });
            setIssues(newIssues);
        });

        Promise.all(defaultPromises).then(results => {
            const newDefaults = {};
            results.forEach(({ id, data }) => {
                if (data) newDefaults[id] = data;
            });
            setdefaultIssues(newDefaults);
        });
    }, [filteredcleaningassignments]);



    useEffect(() => {
        if (
            !filteredcleaningassignments.assignments?.length &&
            !filteredcleaningassignments.defaults?.length
        ) {
            return;
        }

        buildassignmentaccordions(
            filteredcleaningassignments,
            issues,
            defaultIssues
        );
    }, [
        filteredcleaningassignments,
        issues,
        defaultIssues,
        assignmentDescriptions
    ]);


    const onchangedndpicture = (e, assignment, index) => {
        const newFiles = Array.from(e.target.files);
        setDNDPicturesarray(newFiles);
        setAssigmentstarted(0)

    };

    const onchangepicture = (e) => {
        const newFiles = Array.from(e.target.files);
        setPicturesarray(newFiles);
    };


    useEffect(() => {
        if (save === 1 && picturesarray.length > 0 && issueid !== null) {
            const savePromises = picturesarray.map(file => saveFile(file, 2, issueid));
            Promise.all(savePromises)
                .then(results => {
                    // ////console.log('All saveFile results:', results);
                    setSave(0);
                    setIssueid(null);
                    reloadassignments();
                })
                .catch(err => console.error("Error saving pictures:", err));
        }
    }, [picturesarray, save, issueid]);

    const buildassignments = (assignmentId = null) => {
        //////console.log("Rebuilding assignments UI", assignmentId);
        reloadassignments();
    };

    const generatedescription = async (assignment) => {

        let description = "";
        const response = await getCleaningtasks(assignment.hotel_id)
        const body = await response.json();

        const tasksarray = assignment.tasks.split(",");
        for (const task of tasksarray) {


            const taskObject = body.items.find(item => item.Id === parseInt(task));

            if (taskObject) {

                description += `${taskObject.taskDescription}`;
                const json = JSON.parse(assignment.multiple);
                if (json !== null) {

                    if (json["" + taskObject.Id]) {


                        description += `: ${json["" + taskObject.Id]}`;
                    }
                    description += `\n`;
                }
            }
        }
        description += `${assignment.description}`;
        return description;
    }
    const buildassignmentaccordions = async (data, issues, defaults) => {
        setAssigmentstarted(0)
        setAssigmentissueReported(0)
        setRunningassignment(null)
        const typesArray = await Promise.all(
            data.assignments.map(async assignment => {
                if (assignment.status === 1 || assignment.status === 7) {
                    setRunningassignment(assignment.id)
                    setAssigmentstarted(assignment.status)
                }
                if (assignment.status === 4) {
                    setAssigmentstarted(1)
                    setRunningassignment(assignment.id)
                    setAssigmentissueReported(1)
                }
                const cleaningtype = await (await getCleaningtypebyId(assignment.cleaningtype_Id)).json();
                let type;
                if (cleaningtype.items) {
                    type = optionstypes[parseInt(cleaningtype.items.type)] || "Type not recognised, option list needs to be updated";
                }
                return { [assignment.id]: type };  // 👈 return object with assignment.id as key
            })
        );
        const types = Object.assign({}, ...typesArray);
        const typesdefaulsArray = await Promise.all(
            data.defaults.map(async assignment => {
                if (assignment.status === 1 || assignment.status === 7) {
                    setRunningassignment(assignment.id)
                    setAssigmentstarted(assignment.status)
                }
                if (assignment.status === 4) {
                    setAssigmentstarted(1)
                    setRunningassignment(assignment.id)
                    setAssigmentissueReported(1)
                }
                const cleaningtype = await (await getCleaningtypebyId(assignment.cleaningtype_Id)).json();
                let type;
                if (cleaningtype.items) {
                    type = optionstypes[parseInt(cleaningtype.items.type)] || "Type not recognised, option list needs to be updated";
                }
                return { [assignment.id]: type };  // 👈 return object with assignment.id as key
            })
        );
        const typesdefaults = Object.assign({}, ...typesdefaulsArray);
        //onClick={checkreload_assignments}>

        const renderAssignments = (assignments, issueMap, isDefault = false, type = false) =>

            assignments.map((assignment, index) => (
                (assignment.status === 3 || assignment.status === 2 || assignment.status === 8) ? null : // Skip if status is 0
                    <div key={`${assignment.id}-${isDefault ? "default" : "assign"}`} >                         <Accordion.Item
                        eventKey={`${assignment.id}`}
                        className={`CleaningTask CleaningTypeButton_status${assignment.status}`}>
                        <Accordion.Header>
                            <div style={assignment.cleaningtype_type === 0 ? { display: 'block' } : { display: "none" }}><FaBed /></div>
                            <div style={assignment.cleaningtype_type === 1 ? { display: 'block' } : { display: "none" }}><ImExit /></div>
                            <div style={assignment.cleaningtype_type === 2 ? { display: 'block' } : { display: "none" }}><IoIosFlash /></div>
                            <div style={assignment.cleaningtype_type === -2 ? { display: 'block' } : { display: "none" }}><FaRegStar /></div>
                            <div style={assignment.cleaningtype_type === 3 ? { display: 'block' } : { display: "none" }}><BsCalendar2DayFill /></div>
                            <div style={assignment.cleaningtype_type === 4 ? { display: 'block' } : { display: "none" }}><FaCalendarWeek /></div>
                            <div style={assignment.cleaningtype_type === 5 ? { display: 'block' } : { display: "none" }}><FaCalendarXmark /></div>
                            <div style={assignment.cleaningtype_type === -1 ? { display: 'block' } : { display: "none" }}><FaServicestack /></div>
                            &nbsp;-&nbsp;
                            {assignment.title} &nbsp;&nbsp;
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <FaBellConcierge style={{ color: assignment.checkedout === 1 ? "green" : "red", display: assignment.checkedout === 1 ? "flex" : "none" }}></FaBellConcierge>
                                <BiSolidPlaneLand style={{ color: assignment.arrival === 1 ? "green" : "red", display: assignment.arrival === 1 ? "flex" : "none" }}></BiSolidPlaneLand>
                                <FaArrowsRotate style={{ color: assignment.status === 5 ? "green" : "red", display: assignment.status === 5 ? "flex" : "none" }}></FaArrowsRotate>

                            </div>
                            <div className="timeIcon">
                                <label className="iconlabel"><IoIosTimer />: {Intl.NumberFormat('de-DE').format(assignment.calculatedcleaningtime)} min</label>
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>

                            <div>
                                <label className="assignmentlabel">{t('Standaardtaken')}</label>
                                <textarea
                                    className="assignmenttextarea"
                                    value={assignmentDescriptions[assignment.id] || "no tasks described"}
                                    disabled
                                />
                            </div>
                            {assignment.extradescription && (
                                <div>
                                    <label className="assignmentlabel">{t('extrataken')}</label>
                                    <textarea className="assignmenttextarea" value={assignment.extradescription} disabled />
                                </div>
                            )}
                            <div style={{ display: issueMap[assignment.id] && assignment.status == 1 ? "block" : "none" }}>
                                <label className="assignmentlabel">{t('Oplossing melding')}</label>
                                <textarea
                                    className="assignmenttextarea"
                                    value={issueMap[assignment.id]?.resolution || ""}
                                    disabled
                                />
                            </div>
                            <div style={{ display: assignment.status == 5 ? "block" : "none" }}>
                                <label className="assignmentlabel">Remark</label>
                                <textarea
                                    className="Remarktextarea"
                                    value={assignment.status === 5 ? assignment.QAopmerkingen : ""}
                                    disabled
                                />
                            </div>
                            <Accordion style={assignment.cleaningtype_type === -2 || (assigmentstarted === 1) ? { display: "none" } : { display: "block" }}>
                                <Accordion.Item eventKey="0" className="ReportIssue">
                                    <Accordion.Header>{t('DND')}</Accordion.Header>
                                    <Accordion.Body>
                                        <label className="assignmentlabel">{t('DNDRemark')}</label>
                                        <textarea id={`DNDRemark${assignment.id}`} value={assignment.DNDRemark} />

                                        <div id={'DNDPicture' + assignment.id} className="taskbuttoncontainer" style={assignment.cleaningtype_type === -2 || (assigmentstarted === 1) ? { display: "none" } : { display: "block" }}>
                                            <label htmlFor={"files" + assignment.id} className="small_button">{t('AddPicture')}</label>
                                            <input
                                                id={"files" + assignment.id}
                                                type="file"
                                                multiple
                                                style={{ display: "none" }}
                                                onChange={(e) => onchangedndpicture(e, assignment, index)}
                                                accept="image/*"
                                            />
                                        </div>

                                        <Button
                                            className="startAssignmentbutton btn btn-primary margin-right lightgreenTextColor" id="reportissuebutton"
                                            onClick={() => reportAssignmentDND(assignment, `DNDRemark${assignment.id}`)}
                                        >
                                            {t('SaveDND')}
                                        </Button>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                            <br></br>
                            <Button
                                className="startAssignmentbutton btn btn-primary margin-right lightgreenTextColor" id={"startAssignmentbutton_" + assignment.id}
                                // style={{ display: (assignment.status === 0 || assignment.status === 6 || assignment.status === 5) && (assigmentstarted !== 1 && assigmentissueReported !== 1) && runningassignment !== assignment.id ? "block" : "none" }}
                                style={{ display: runningassignment === assignment.id || assigmentstarted > 0 ? "none" : "block" }}
                                disabled={assigmentstarted === 1 || assignment.status === 4 ? true : false}
                                onClick={() => startCleaningAssignment(assignment)}
                            >{assignment.cleaningtype_type === -2 ? t('StartSpecialRequest') : assignment.status === 5 ? t('StartRECLEAN') : t('Startcleaningjob')}
                                {/* | {assigmentstarted} | {runningassignment} | {assignment.id} */}
                            </Button>

                            <Button
                                className="startAssignmentbutton btn btn-primary margin-right lightgreenTextColor" id={"stopAssignmentbutton_" + assignment.id}
                                // style={{ display: assignment.status > 0 && assignment.status !== 3 && assignment.status !== 6 && assignment.status !== 5 ? "block" : "none" }}
                                style={{ display: runningassignment !== assignment.id ? "none" : "block" }}
                                onClick={() => stopCleaningAssignment(assignment)}
                            >
                                {assignment.cleaningtype_type === -2 ? t('StopSpecialRequest') : assignment.status === 7 ? t('StopRECLEAN') : t('Endcleaningjob')}
                                {/* | {assigmentstarted} | {runningassignment} | {assignment.id} */}
                            </Button>
                            {assignment.status > 0 && assignment.status !== 6 && !issueMap[assignment.id] && (
                                <Accordion >
                                    <Accordion.Item eventKey="0" className="ReportIssue">
                                        <Accordion.Header>{t('reportIssue')}</Accordion.Header>
                                        <Accordion.Body>
                                            <label className="assignmentlabel">{t('Description')}</label>
                                            <textarea id={`IssueReportDescription${assignment.id}`} />

                                            <div className="taskbuttoncontainer">
                                                <label htmlFor="files" className="small_button">{t('AddPicture')}</label>
                                                <input
                                                    id="files"
                                                    type="file"
                                                    multiple
                                                    style={{ display: "none" }}
                                                    onChange={onchangepicture}
                                                    accept="image/*"
                                                />
                                            </div>

                                            <Button
                                                className="startAssignmentbutton btn btn-primary margin-right lightgreenTextColor" id="reportissuebutton"
                                                onClick={() => reportAssignmentIssue(assignment, `IssueReportDescription${assignment.id}`)}
                                            >
                                                {t('SaveIssue')}
                                            </Button>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            )}
                        </Accordion.Body>
                    </Accordion.Item>
                        <br />
                    </div>
            )
            );


        const items = [
            ...renderAssignments(data.assignments.sort((a, b) => a.hotel_id - b.hotel_id), issues),
            ...renderAssignments(data.defaults.sort((a, b) => a.hotel_id - b.hotel_id), defaults, true)
        ];

        setcleaningassignmentsarray(items);
    };

    //dndassigment
    const dndCleaningAssignment = (assignment, DNDRemark) => {
        //assignment.status = 6;
        const now = new Date();
        const time = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
        dndassigment(assignment.id, time, DNDRemark).then(res => {
            if (res.status === 200) {
                reloadassignments();

            } else {
                setErrorMessage(res.statusText);
            }
        });
    };



    const startCleaningAssignment = (assignment) => {
        if (assignment.status === 5) {
            startReCleaningAssignment(assignment)
        } else {

            document.getElementById("startAssignmentbutton_" + assignment.id).disabled = true
            assignment.status = 4;
            const now = new Date();
            const time = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
            startassigment(assignment.id, time).then(res => {
                if (res.status === 200) {
                    reloadassignments();

                } else {
                    setErrorMessage(res.statusText);

                }
            });
        }
    };
    const startReCleaningAssignment = (assignment) => {
        assignment.status = 4;
        setAssigmentstarted(assignment.id)
        const now = new Date();
        const time = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
        startRecleanassigment(assignment.id, time).then(res => {
            if (res.status === 200) {
                reloadassignments();

            } else {
                setErrorMessage(res.statusText);
            }
        });
    };

    const ReportIssueCleaningAssignment = (assignment) => {
        //document.getElementById("reportissuebutton").disabled = true
        ReportIssueassigment(assignment.id).then(res => {
            if (res.status === 200) {
                //reloadassignments();
            } else {
                setErrorMessage(res.statusText);

            }
        });
    };


    const stopCleaningAssignment = (assignment) => {
        if (assignment.status === 7) {
            stopReCleaningAssignment(assignment)
        } else {
            document.getElementById("stopAssignmentbutton_" + assignment.id).disabled = true
            // document.getElementById("reportissuebutton").disabled = true
            assignment.status = 4;
            setAssigmentissueReported(0)
            const now = new Date();
            let status = 3;
            if (assignment.cleaningtype_type === 0) {
                if (QAcontrole === 3 || QAcontrole === 2) {
                    status = 3;

                }
            }
            if (assignment.cleaningtype_type === 1) {
                if (QAcontrole === 3 || QAcontrole === 1) {
                    status = 3;
                }
            }
            if (QAcontrole === 4) {
                status = 2;
            }
            const time = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
            stopassigment(assignment.id, time, status).then(res => {
                if (res.status === 200) {
                    //buildassignments(assignment.id);
                    reloadassignments();

                } else {
                    setErrorMessage(res.statusText);

                }
            });
        }
    };
    const stopReCleaningAssignment = (assignment) => {
        assignment.status = 4;
        setRunningassignment(null)
        setAssigmentstarted(0)
        const now = new Date();
        let status = 3;
        if (assignment.cleaningtype_type === 0) {
            if (QAcontrole === 3 || QAcontrole === 2) {
                status = 3;

            }
        }
        if (assignment.cleaningtype_type === 1) {
            if (QAcontrole === 3 || QAcontrole === 1) {
                status = 3;
            }
        }
        if (QAcontrole === 4) {
            status = 2;
        }
        const time = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
        //console.log("time : ", time)
        stopRecleanassigment(assignment.id, time, status).then(res => {
            if (res.status === 200) {
                buildassignments(assignment.id);
                reloadassignments();
            } else {
                setErrorMessage(res.statusText);
            }
        });
    };

    const reportAssignmentDND = (assignment, inputId) => {
        setSave(1);
        //ReportIssueCleaningAssignment(assignment)
        const DNDRemark = document.getElementById(inputId).value;
        if (dndpicturesarray.length > 0) {
            const savePromises = dndpicturesarray.map(file => saveFile(file, 4, assignment.id));
            Promise.all(savePromises)
                .then(results => {
                    //console.log('All saveFile results:', results);
                    dndCleaningAssignment(assignment)
                })
                .catch(err => console.error("Error saving pictures:", err));
        }
        dndCleaningAssignment(assignment, DNDRemark)


    };

    const reportAssignmentIssue = (assignment, inputId) => {
        setSave(1);
        //ReportIssueCleaningAssignment(assignment)
        const description = document.getElementById(inputId).value;
        const existingIssue = issues[assignment.id];

        if (existingIssue) {
            updateIssue(existingIssue.id, { "description": description }).then(res => {
                if (res.status === 200) {
                    setIssueid(existingIssue.id);
                    buildassignments(assignment.id);
                } else {
                    setErrorMessage(res.statusText);
                }
            });
        } else {
            createIssue(assignment.id, null, description).then(res => {
                if (res.status !== 200) {
                    setErrorMessage(res.statusText);
                    return;
                }

                res.json().then(data => {
                    const newIssueId = data[0];
                    setIssueid(newIssueId);
                    reportassigmentissue(assignment.id, null).then(res => {
                        if (res.status === 200) {
                            buildassignments(assignment.id);
                        } else {
                            setErrorMessage(res.statusText);
                        }
                    });
                });
            });
        }
    };

    const toMainScreen = () => {
        navigate("/")
    };

    return (

        <div id="main" className="main">
            <header>
                <div id="errordiv" className="error" />
                <div id="messagediv" className='message'>
                    <center>
                        <div id="messagetext" className="MessageText"></div>
                        <br></br><br></br>  <br></br> <br></br>
                        <Button type="button" id="CloseMessageButton" className="OkCancel" onClick={toMainScreen}>Ok</Button>
                    </center>
                </div>
                <div className="checkinTime">
                    <div id="timelabel" />
                    <div id="time" />
                </div>
            </header>
            <br />
            <Accordion id="Assignmentsaccordion">
                {cleaningassignmentsarray}
            </Accordion>
        </div>
    );
};

export default MyCleaningTasks;